module.exports = __webpack_public_path__ + "img/signal_yellow.dcd7c137.png";